<script setup>
import DropdownMenuItem from '@/components/shared/dropdown/DropdownMenuItem.vue'
import {useAppTheme} from '@/composables/use-app-theme.js'

//Composables
const {isDarkTheme, toggleTheme} = useAppTheme()
</script>

<template>
  <DropdownMenuItem
    :icon="isDarkTheme ? 'light_mode' : 'dark_mode'"
    :label="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'"
    @click="toggleTheme()"
  />
</template>
